<template>
  <div class="SegundaViaObito">
    <div class="SegundaViaObito_body">
      <div class="SegundaViaObito_header">
        Dados do registro
      </div>
      <div class="SegundaViaobito_body_content p-2">
        <div class="px-2 pt-2 mb-4"
             name="formAddRegistrador">
          <div class="row">
            <div class="col-sm-5">
              <label
                class="label"
                for="falecido_digitador_nome">Nome do Digitador</label>
              <select
                id="falecido_digitador_nome"
                v-model="obito.registro.digitador"
                v-validate="'required'"
                :class="{'is-invalid' : errors.has('digitador')}"
                required
                class="custom-select custom-select-sm"
                name="digitador"
                :disabled="!digitadores.length"
                @change="changed">
                <option v-if="!digitadores.length"
                        value="">
                  Não existem digitadores
                </option>
                <option v-for="(usuario, index) in digitadores"
                        :key="index"
                        :value="usuario.nome">
                  {{ usuario.nome }}
                </option>
              </select>
              <small v-if="errors.has('digitador')"
                     class="invalid-feedback">
                {{ errors.first('digitador') }}
              </small>
            </div>

            <div class="col-sm-4">
              <label
                class="label"
                for="escrevente">Escrevente</label>
              <select
                id="escrevente"
                v-model="obito.registro.escrevente"
                v-validate="'required'"
                class="custom-select custom-select-sm"
                :class="{'is-invalid' : errors.has('escrevente')}"
                required
                name="escrevente"
                :disabled="!escreventes.length"
                @change="changeEscrevente()">
                <option v-if="!escreventes.length"
                        value="">
                  Não existem escreventes
                </option>
                <option v-for="(escrevente, index) in escreventes"
                        :key="index"
                        :value="escrevente.nome">
                  {{ escrevente.nome }}
                </option>
              </select>
              <small v-if="errors.has('escrevente')"
                     class="invalid-feedback">
                {{ errors.first('escrevente') }}
              </small>
            </div>
          </div>
        </div>
        <div v-if="obito.registro.origem === 'legado' || obito.registro.registro_id"
             class="row px-2 mb-4">
          <div class="col-2">
            <label
              class="label"
              for="falecido_digitador_nome">Livro</label>
            <input v-model="obito.registro.livro.num_livro"
                   v-validate="'required'"
                   type="number"
                   name="registro_livro"
                   :class="{'is-invalid' : errors.has('registro_livro')}"
                   class="form-control form-control-sm"
                   @change="verifyOrigin()">
          </div>

          <div class="col-2">
            <label
              class="label"
              for="falecido_digitador_nome">Folha</label>
            <input v-model="obito.registro.folha"
                   v-validate="'required'"
                   type="number"
                   name="registro_folha"
                   :class="{'is-invalid' : errors.has('registro_folha')}"
                   class="form-control form-control-sm"
                   @change="verifyOrigin()">
          </div>

          <div class="col-2">
            <label
              class="label"
              for="falecido_digitador_nome">Termo</label>
            <input v-model="obito.registro.termo"
                   v-validate="'required'"
                   type="number"
                   name="registro_termo"
                   :class="{'is-invalid' : errors.has('registro_termo')}"
                   class="form-control form-control-sm"
                   @change="verifyOrigin()">
          </div>
          <div class="col-3">
            <div class="form-group">
              <label
                class="label"
                for="data_registro">Data do Registro</label>
              <input
                id="data_registro"
                v-model="obito.registro.data_registro"
                v-validate="`date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
                required
                class="form-control form-control-sm"
                name="data_registro"
                :class="{ 'is-invalid': errors.has('data_registro') }"
                placeholder="09/08/2019"
                type="date"
                @change="changed(obito.registro), verifyOrigin()">
              <small v-if="errors.has('data_registro')"
                     class="invalid-feedback">{{ errors.first('data_registro') }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SegundaViaObito">
      <div class="SegundaViaObito_header">
        Falecido
      </div>
      <div class="SegundaViaObito_content p-2">
        <FalecidoSV :prop-registro="obito.registro"
                    :prop-obito="obito"
                    @removeGenitor="removeGenitor"
                    @changed="changed"
                    @documentoRemoved="documentoRemoved" />
      </div>
    </div>
    <div class="SegundaViaObito">
      <div class="SegundaViaObito_header">
        Dados do falecimento
      </div>
      <div class="SegundaViaObito_content p-2">
        <DadosFalecimentoSV :prop-obito="obito"
                            @changed="changeObito"
                            @medicoRemoved="excluirMedico" />
      </div>
    </div>
    <hr>
    <div class="row justify-content-end mr-2">
      <button v-if="obito.registro && obito.registro.existe_crc"
              id="btn-submit-registro"
              class="btn btn-sm btn-primary"
              type="button"
              :disabled="enabledSave()"
              @click="verificarDados()">
        Salvar
      </button>
      <button v-else
              id="btn-submit-registro"
              class="btn btn-sm btn-primary"
              type="button"
              :disabled="enabledSave()"
              @click="verifyInputs">
        Salvar
      </button>
    </div>
    <MotivoAlteracao tipo="N"
                     :tarefa-alteracao-carga="tarefaAlteracaoCarga"
                     @gravarAtualizacao="save($event)" />
  </div>
</template>

<script>
  //components
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'
  import FalecidoSV from '@/components/SofiaRei/Obito/SegundaVia/FalecidoSV.vue'
  import DadosFalecimentoSV  from '@/components/SofiaRei/Obito/SegundaVia/DadosFalecimentoSV.vue'

  //services
  import ObitoService from "@/services/Registros/Obito"
  import UsuarioService from "@/services/Auth/UsuarioService"

  //outros
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SegundaViaObito',
    components: {
      MotivoAlteracao,
      FalecidoSV,
      DadosFalecimentoSV
    },
    props: {
      propObito: { type: Object, default: null}
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        obito: {
          registro: {
            pessoa: {}
          }
        },
        tarefaAlteracaoCarga: null,
        deleteds: { genitores: [], medicos: [], pessoaDocumentos: [] },
        escreventes: [],
        digitadores: [],
        sequenciaRegistro: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorioId: 'auth/getCartorioId'
      }),
    },
    async mounted () {
      this.obito = {
        ...this.propObito,
        registro: {
          ...this.propObito.registro,
          pessoa: {
            ...this.propObito.registro.pessoa,
            genitores: this.propObito.registro.pessoa.genitores.map((genitor) => {
              return {
                ...genitor,
                pessoa: {
                  ...genitor.pessoa,
                  endereco: {...genitor.pessoa.endereco}
                },
              }
            })
          }
        }
      }

      this.obito.registro = {
        digitador: this.user.nome,
        escrevente: this.user.escrevente ? this.user.nome : '',
        cargo_escrevente: this.user.escrevente ? this.user.cargo : '',
        ...this.obito.registro,
      }

      if (!this.obito.registro.escrevente) {
        this.obito.registro.escrevente = this.user.escrevente ? this.user.nome : ''
      }

      this.changed(this.obito.registro)
      await this.loadUsers()

    },
    methods: {
      async loadUsers () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        this.digitadores = []

        let usuarios = response.data || []

        this.digitadores = usuarios
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )
      },
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        if (this.obito.registro.pessoa.data_obito) {
          return moment(this.obito.registro.pessoa.data_obito).format("YYYY-MM-DD")
        } else {
          return moment('1500/01/01').format("YYYY-MM-DD")
        }
      },
      changed (registro) {
        this.obito = {
          registro,
          ...registro,
          ...this.obito,
          pessoa: registro.pessoa,
          documentos: registro.pessoa.documentos
        }
      },
      changeObito (obito) {
        this.obito = obito
      },
      verifyOrigin () {
        if (this.obito.registro.registro_id) {
          let { livro: { num_livro }, folha, termo } = this.obito.registro
          const sequenciaLocal = [num_livro, folha, termo].join('')

          if ((this.sequenciaRegistro != sequenciaLocal) || (this.obito.data_registro != this.propObito.registro.data_registro)) {
            this.obito.registro.origem = 'legado'
          } else {
            this.obito.registro.origem = 'novo'
          }
        }
      },
      changeOrigin (origem) {
        if (origem === 'novo') {
          this.obito.registro = {
            ...this.obito.registro,
            termo: null,
            livro: {
              num_livro: null
            },
            folha: null,
            lado: null
          }
        }
      },
      async verificarDados () {
        const valid = await this.$validator.validateAll()

        const invalids = await this.scrollList()

        if (invalids || !valid) return

        this.$root.$emit('bv::show::modal', 'modalMotivoAlteracao')
      },
      scrollList () {
        const listagem = document.querySelectorAll('.is-invalid')

        if (listagem.length) {
          listagem[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }

        return listagem.length
      },
      async save ($event = null) {

        const data = $event

        try {
          loader({ text: "Atualizando registro...", active: true })

          this.obito.deleteds = this.deleteds
          // Motivos registro
          this.obito.registro.cod_motivo_alt = this.motivo_alteracao
          this.obito.registro.data_averb_motivo_alt = this.motivo_alteracao_data

          this.obito.medicos.forEach((medico, index)=> {
            if (medico && !medico.nome) {
              this.obito.medicos.splice(index, 1)
            }
          })

          this.setInclusoes()

          if (data) {
            this.obito.registro.cod_motivo_alt = data.codigo
            this.obito.registro.data_averb_motivo_alt = data.dataAverb
          }

          if (this.obito.numero_declaracao_obito) {
            this.obito.numero_declaracao_obito = this.obito.numero_declaracao_obito.replace('-', '').replace('-', '')
          } else {
            this.obito.numero_declaracao_obito = null
          }

          if (!this.obito.sem_declaracao_obito) this.obito.sem_declaracao_obito = false

          if (!this.obito.registro.oficial) {
            this.obito.registro.oficial = this.cartorio.nome_oficial
          }

          const res = await ObitoService.editarObito(this.obito)

          if (res) {
            displayMessage('question', 'Sucesso!', 'Deseja emitir uma ordem de serviço.').then((res) => {
              if (res.value) {
                this.obito.deleteds = { genitores: [], medicos: [], pessoaDocumentos: [] }
                this.deleteds = { genitores: [], medicos: [], pessoaDocumentos: [] }

                this.$emit('goOS', this.obito)
              } else {
                this.$emit('changeRegistro', this.obito)
              }
            })
          }
        } catch (error) {
          if (Array.isArray(error.response && error.response.data)) {
            const messages = []

            error.response.data.forEach(resp => {
              switch (resp.message) {
              case 'unique validation failed on numero_declaracao_obito':
                messages.push(`A D.O ${this.obito.numero_declaracao_obito} já está vinculada à outro registro`)
                break
              case 'sofia validation failed on numero_declaracao_obito':
                messages.push(`D.O Número ${this.obito.numero_declaracao_obito} não é válida.`)
                break
              }
            })

            this.showErrorList(messages)

          } else {
            if (error.response && error.response.data.message && !error.response.data.message.message) {
              return this.displayError('TEXT', error.response.data.message)
            } else {
              return this.displayError('TEXT', 'Houve algum erro ao editar o registro de óbito, favor contactar o suporte.')
            }
          }
        }
        finally {
          loader({text: "", active: false})
        }

      },
      setInclusoes () {
        // Inclusão de Documentos
        if (this.obito.pessoa && this.obito.pessoa.documentos) {
          this.obito.pessoa.documentos.map(doc => {
            doc.pessoa_id = this.obito.pessoa.pessoa_id
          })
        }

        // Inclusão de Filhos
        if (this.obito.filhoDeixado) {
          this.obito.filhoDeixado.map(filho => {
            filho.obito_id = this.obito.obito_id
          })
        }

        // Innclusão de Médicos
        if (this.obito.medicos) {
          this.obito.medicos.map(medico => {
            medico.obito_id = this.obito.obito_id
          })
        }

        // Innclusão de Partes
        if (this.obito.registro.partes) {
          this.obito.registro.partes.map(parte => {
            parte.registro_id = this.obito.registro.registro_id
          })
        }

      },
      removeGenitor (genitor_id) {
        this.deleteds.genitores.push(genitor_id)
      },
      verifyInputs ($event) {
        this.$validator.validate().then(resp => {
          if (!resp) {
            let invalids = document.querySelectorAll('.is-invalid')

            return this.invalids(invalids)
          }

          const {errors: {items}} = this.$validator
          const messages = []

          items.forEach(item => {
            switch (item.field) {
            case 'nome':
              messages.push('Informe o nome do registrado')
              break
            case 'data_nascimento':
              messages.push('Data de nascimento inválida')
              break
            case 'data_ocorrido':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do ocorrido') : messages.push('Data do ocorrido inválida')
              break
            case 'hora_ocorrido':
              messages.push('Hora do ocorrido inválida')
              break
            case 'numero_declaracao_obito':
              messages.push('Nº Declaração óbito inválido')
              break
            case 'data_registro':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do registro') : messages.push('Data do registro inválida')
              break
            case 'registro_livro':
              messages.push('Informe o número do livro')
              break
            case 'registro_folha':
              messages.push('Informe o número da folha')
              break
            case 'registro_termo':
              messages.push('Informe o número do registro')
              break
            }
          })

          let invalids = document.querySelectorAll('.is-invalid')

          this.invalids(invalids)


          if (resp && !items.length && !this.enabledSave()) {
            return this.save($event)
          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
            if (messages.length) this.showErrorList(messages)
          }

        })
      },
      enabledSave () {
        let disableIt = false

        if ((!this.obito.registro.pessoa.nome) || (!this.obito.registro.pessoa.cpf && !this.obito.registro.pessoa.cpf_sem_inscricao)) {
          disableIt = true
        }

        return disableIt
      },
      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar registro de óbito'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error)
      },
      excluirMedico (medico) {
        if (medico && medico.medico_id) {
          this.deleteds.medicos.push(medico.medico_id)
        }
      },
      documentoRemoved (documento) {
        if (!documento.pessoa_documento_id) return
        this.deleteds.pessoaDocumentos.push(documento.pessoa_documento_id)
      },
      changeEscrevente () {
        if (this.obito.registro.escrevente) {
          const selectEscreventes = document.getElementById('escrevente')
          this.obito.registro.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex].cargo
        }
        this.changed(this.obito.registro)
      }
    }
  }
</script>

<style lang="scss">
  .SegundaViaObito {
    &_header {
      background-color: #074F7F !important;
      color: white !important;
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
      border-radius: 0px;
    }


    &_body {
      &_header {
        background-color: #eaeaea !important;
        color: #000 !important;
        padding: 10px;
        font-size: 16px;
        font-weight: bold;
        border-radius: 0px;
      }
    }
  }
</style>
